import React from 'react'
import * as url from '_routes/url-names'
import AuthRoute from '_routes/authenticated-route'

const Interview = React.lazy(() => import('_containers/interview/overview'))
const VacantInterviews = React.lazy(() => import('_containers/interview/vacant'))
const InvitedInterviews = React.lazy(() => import('_containers/interview/invited'))
const BookedInterviews = React.lazy(() => import('_containers/interview/booked'))
const ClosedInterviews = React.lazy(() => import('_containers/interview/closed'))

export default [
  {
    path: url.COMPANY + url.INTERVIEW,
    element: <AuthRoute component={Interview} />,
    children: [
      { index: true, element: <AuthRoute component={VacantInterviews} /> },
      { path: url.COMPANY + url.INTERVIEW + url.INT_INVITED, element: <AuthRoute component={InvitedInterviews} /> },
      { path: url.COMPANY + url.INTERVIEW + url.INT_BOOKED, element: <AuthRoute component={BookedInterviews} /> },
      { path: url.COMPANY + url.INTERVIEW + url.INT_HISTORY, element: <AuthRoute component={ClosedInterviews} /> }
    ]
  }
]
